module.exports = __webpack_public_path__ + "img/fastpay_white.de18dac3.png";